// import React from "react";
// import { Outlet } from "react-router-dom";
// // import Header from "./Header";
// import HeaderManager from "./HeaderManager";
// import Footer from "./Footer";
// import BackToTop from "./BackToTop";
// const Layout = () => {
//     return (
//         <>
//             <HeaderManager />
//             {/* <Header /> */}
//             <main style={{ minHeight: "40vh" }}>
//                 <Outlet />
//             </main>
//             <Footer />
//             <BackToTop /> {/* Always visible but only shows after scroll */}
//         </>
//     );
// };

// export default Layout;



import React from "react";
import { Outlet } from "react-router-dom";
import HeaderManager from "./HeaderManager";
import Footer from "./Footer";
import BackToTop from "./BackToTop";
import DemoNotice from "./DemoNotice";
import { siteConfig } from "./siteConfig";

const Layout = () => {
    return (
        <>
            {/* 🔴 Website open hote hi notice */}
            {siteConfig.showDemoNotice && <DemoNotice />}

            <HeaderManager />

            <main style={{ minHeight: "40vh" }}>
                <Outlet />
            </main>

            <Footer />
            <BackToTop />
        </>
    );
};

export default Layout;
